import zod from "zod";
import { LngLatBoundsLike } from "mapbox-gl";

export type Position = [number, number];

export const DEFAULT_MAX_BOUNDS = [
  111.3988, -44.2272, 156.4499, -9.8494,
] as LngLatBoundsLike;

export const MIN_WIDTH_FOR_PADDING_LEFT_APPLY = 896;

export type AmpolService = zod.infer<
  ReturnType<typeof createAmpolServiceSchema>
>;
export const createAmpolServiceSchema = () =>
  zod.object({
    $id: zod.string(),
    name: zod.string(),
    position: zod.number().array(),
    addressLineOne: zod.string().optional(),
    locality: zod.string().optional(),
    postalCode: zod.string().optional(),
    region: zod.string().optional(),
    phoneNumber: zod.string().optional(),
    services: zod.string().array().optional(),
    hours: zod.string().optional(),
  });

export type AmpolServiceData = zod.infer<
  ReturnType<typeof createAmpolServiceDataSchema>
>;
export const createAmpolServiceDataSchema = () =>
  zod.array(createAmpolServiceSchema());

export const fuelTypes = {
  ULP: "Unleaded 91",
  E10: "Ethanol 94",
  // E95: "Unleaded 95",
  VX95: "Premium 95",
  VX98: "Premium 98",
  VXDSL: "Premium Diesel",
  // BIO: "Bio diesel",
  DSL: "Diesel",
  EV: "EV Charge",
  LPG: "LPG",
  // BIO: "Ethanol 105",
};
